<template>
  <div>
   <div
    v-for="(item, index) in contatos"
      :key="index"
    >
      <div class="grid-row">
        <div class=" titulo-grid">
          Contato {{ index + 1 }}
        </div>
      </div>
      <div class="grid-row">
        <div class=" titulo">
          Nome
        </div>
        <div class="">
          {{ item.nome.toUpperCase() }}
        </div>
        <div class=" titulo">
          Celular
        </div>
        <div class="">
          {{ item.celular }}
        </div>
      </div>
      <div class="grid-row">
        <div class=" titulo">
          E-mail
        </div>
        <div class="">
          {{ item.email }}
        </div>
        <div class=" titulo">
          Telefone
        </div>
        <div class="">
          {{ item.telefone }}
        </div>
      </div>
    </div>
  </div>  
</template>

<script>


export default {
  name: "ContatosPcoCircuitoComponent",
  props: {
    contatos: {
      type: Array,
      required: true
    }
  }
}
</script>